import React from 'react';
import { InputLabel, Select, MenuItem } from '@mui/material';
import Grid from '@mui/material/Grid2';
import makeStyles from '@mui/styles/makeStyles';
import { FastField } from 'formik';
import * as mh from '../../helpers/mobile';

const useStyles = makeStyles(() => ({
  select: {
    fontSize: '0.75rem',
  },
}));

const FormSelect = ({ fullWidth, size, items, ...rest }) => {
  const classes = useStyles();
  const isPortrait = mh.isPortrait();
  const ItemComp = isPortrait ? 'option' : MenuItem;
  return (
    <Grid size={{ xs: fullWidth ? 12 : size }} style={rest.style}>
      <FastField {...rest}>
        {({ field }) => {
          return (
            <>
              {rest.label && (
                <InputLabel
                  classes={{
                    root: classes.select,
                  }}
                >
                  {rest.label}
                </InputLabel>
              )}
              <Select
                variant="standard"
                fullWidth
                native={isPortrait}
                {...field}
                value={field.value ?? ''}
                label={rest.label}
                renderValue={rest.renderValue}
                error={!field.value && rest.required}
              >
                {items.map(item => (
                  <ItemComp key={item.value} value={item.value}>
                    {item.name}
                  </ItemComp>
                ))}
              </Select>
            </>
          );
        }}
      </FastField>
    </Grid>
  );
};

FormSelect.defaultProps = {
  size: 6,
  items: [],
};

export default FormSelect;
